module.exports = __webpack_public_path__ + "static/media/icon-currency.89ced5da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-currency.svg
// module id = 2894
// module chunks = 0